export default {
  deta () {
    return {
      cbName: ''
    }
  },
  methods: {
    // 解绑/绑定 前 刷新一下绑定信息
    // 如果绑定信息只有一个,会停止解绑
    mixinsRefreshBindInfo (cbName) {
      this.cbName = cbName
      this.once_key = this.$utils.getTS()
      this.$Spin.show()
      this.$socket.push({
        params: {
          action: 'get_bind_info',
          once_key: this.once_key
        },
        cb: this.getBindInfoHandler,
      })
    },
    getBindInfoHandler (resp) {
      if (resp.action !== 'get_bind_info' && resp.once_key !== this.once_key) return
      this.$Spin.hide()
      if (resp.code === 0) {
        this.$store.commit('setBindInfo', resp.user_info)
        this[this.cbName] && this[this.cbName]()
      } else {
        this.$msg.success(resp.code ? this.$t(`KGSDK_${resp.code}`) : this.$t('network_err'))
        this.mixinsRefreshBindInfo()
      }
    }
  },
}